module.exports = __webpack_public_path__ + "static/img/5792_phase_function_Paper_PointsHejduk_Prediction.00ca8ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5792_phase_function_Paper_PointsHejduk_Prediction.png
// module id = bi8J
// module chunks = 0